import * as yup from "yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoMailOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import ReactSelect from "../../../components/common/ReactSelect";
import Datepicker from "../../../components/common/Datepicker";
import Toaster from "./../../../components/common/Toaster";
import accountService from "./../../../services/accountService";
import moment from "moment";

const income_types = [
  { value: "Professional", label: "Professional" },
  { value: "Business", label: "Business" },
];

const schema = yup.object({
  income_type: yup.object().shape({
    label: yup.string().required("Please select income type."),
    value: yup.string().required("Please select income type."),
  }),
  year: yup.string().required("Please select year."),
});

const SwornDeclarationForm = ({ data, isLoading, setLoading, onSuccess }) => {
  const [currentYear] = useState(
    Date.parse(moment(new Date(), "YYYY").toISOString())
  );

  const {
    register,
    handleSubmit,
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (info) => {
    try {
      setLoading(true);

      const item = { ...info };
      item["income_type"] = info.income_type.value;
      item["year"] = info.year.slice(info.year.length - 4);

      await accountService.generateSwornAsync(data.id, item);
      Toaster.Success("Sworn Declaration Sent Successfully!");

      setLoading(false);
      onSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="income-type-dropdown"
            name="income_type"
            title="Income Type"
            options={income_types}
            control={control}
            register={register("income_type")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <Datepicker
            id="year-datepicker"
            name="year"
            title="Year"
            dateFormat="YYYY"
            setValue={setValue}
            clearErrors={clearErrors}
            register={register("year")}
            timeFormat={false}
            initialValue={currentYear}
            errors={errors}
            readOnly
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoMailOutline className="mr-3" />}
            Send via Email
          </button>
        </div>
      </div>
    </form>
  );
};

export default SwornDeclarationForm;
